import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { addComparisonPlan, removeComparisonPlan } from '../../../actions/searchActions';
import { formatURL, isMobile, isB2b, cleanDate } from '../../../utils';
import styles from './styles.module.css';

const ComparisonBarModule = (props) => {
  const comparePlans = () => {
    const selectedPlans = props.plans.map((plan) => plan.code);
    let basePath = '/seguro-viagem/comparacao';
    if (isB2b()) basePath = '/seguro-viagem/comparacao-b2b';

    const location = {
      pathname: formatURL(
        props.match.params,
        `${basePath}/${props.match.params.destination}/${cleanDate(props.match.params.begin_date)}/${cleanDate(
          props.match.params.end_date
        )}/?products_ids=${selectedPlans.join('+')}`
      ),
    };
    props.history.push(location);
  };

  let plans = [{}, {}, {}, {}];
  if (isMobile()) plans = [{}, {}];
  plans = plans.map((plan, i) => props.plans[i] || plan);

  const getProviderImgPath = (providerCode) => {
    const provider = props.providers.find((p) => p.code === providerCode);
    return provider ? `/assets/images/seguradoras/${provider.slug}.png` : '';
  };

  return (
    <section className={styles.planos}>
      <div className={styles.component}>
        <div className={styles.planosComparar}>
          <p className={styles.escolha}>Escolha de 2 a 4 planos para fazer uma comparação</p>
          <ul className={styles.planosSelecionados}>
            {plans.map((plan, i) => (
              <li
                key={i}
                className={`${styles.itemSelectedPlans} ${!plan.code ? styles.notSelected : ''}`}
                onClick={() => plan.code && props.removeComparisonPlan(plan.code)}
              >
                {plan.code ? (
                  <React.Fragment>
                    <span className={styles.delete}>
                      <img src="/assets/images/pagamento/excluir.svg" alt="Excluir plano" />
                    </span>
                    <div className={styles.mini}>
                      <img src={getProviderImgPath(plan.provider_code)} alt={plan.provider_code ? 'Provider logo' : 'Sem logo'} />
                    </div>
                  </React.Fragment>
                ) : (
                  <React.Fragment>
                    <span className="desktop">Selecione outro seguro para comparar</span>
                    <span className="mobile">Selecione outro plano</span>
                  </React.Fragment>
                )}
              </li>
            ))}
          </ul>

          <button
            className={styles.btnCompare}
            onClick={comparePlans}
            disabled={props.plans.length <= 1}
            data-cy="botao-comparar"
          >
            Comparar
          </button>
        </div>
      </div>
    </section>
  );
};

const mapStateToProps = (state) => ({
  plans: state.search.comparisonPlans,
  providers: state.global.providers,
});

export default withRouter(
  connect(mapStateToProps, {
    addComparisonPlan,
    removeComparisonPlan,
  })(ComparisonBarModule)
);



// WEBPACK FOOTER //
// ./src/components/search/comparison_bar/ComparisonBar.module.jsx